import {
  type PartialProfile,
  getProfileResponseSchema,
  minimalProfileUpdateRequestSchema,
  minimalProfileUpdateResponseSchema,
} from "@mg/schemas/src/christo/profile";
import { z } from "zod";

import { API_URL } from "../config/env";
import { smartFetch } from "../utils/http";
import { login } from "../utils/slices/auth";
import { store } from "../utils/store";

const completeOnboardingResponseSchema = z.object({
  token: z.string(),
});

export async function completeOnboarding() {
  const json = await smartFetch(`${API_URL}/private/profile/onboard`, {
    method: "POST",
  });

  const parsedData = completeOnboardingResponseSchema.parse(json);

  return parsedData;
}

export async function getUserProfile() {
  const json = await smartFetch(`${API_URL}/private/profile`, {
    method: "GET",
  });

  const parsedData = getProfileResponseSchema.parse(json);

  return parsedData;
}

export async function updateCurrentUserProfile(payload: PartialProfile) {
  const json = await smartFetch(`${API_URL}/private/profile`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });

  const parsedData = getProfileResponseSchema.parse(json);

  // Only update auth slice if we have a token
  const response = json as { token?: string };
  if (response.token) {
    store.dispatch(login({ token: response.token }));
  }

  return parsedData;
}

// Alias for backward compatibility with onboarding routes
export const updateUserProfile = updateCurrentUserProfile;

export async function updateMinimalUserProfile(payload: {
  avatar?: string | null;
  name?: string;
  preferredName?: string;
}) {
  // Validate request payload
  minimalProfileUpdateRequestSchema.parse(payload);

  const json = await smartFetch(`${API_URL}/private/profile/minimal`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });

  // Parse response
  const parsedData = minimalProfileUpdateResponseSchema.parse(json);

  // Update auth slice with new token and invalidate profile queries
  store.dispatch(login({ token: parsedData.token }));

  return parsedData;
}

export async function checkUsernameUniqueness(preferredName: string) {
  const json = await smartFetch(`${API_URL}/private/profile/check-username`, {
    method: "POST",
    body: JSON.stringify({ preferredName }),
  });

  return json as { isUnique: boolean };
}
